import { gql } from '@apollo/client';
import { gqlPartialBauAccountDetails } from 'graphqls/graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface AccountToRecover extends gqlPartialBauAccountDetails {
  instance: string;
  username: string;
}

export const PARTIAL_BAU_ACCOUNT_DETAILS = gql`
  query partialBauAccountDetails($input: PartialBauAccountDetailsInput!) {
    partialBauAccountDetails(input: $input) {
      roles {
        code
      }
      partialEmail
      partialPhones
      stageName
      accountStatusCode
    }
  }
`;

export const GET_ACCOUNT_TO_RECOVER = gql`
  {
    accountToRecover @client {
      roles {
        code
      }
      partialEmail
      partialPhones
      stageName
      instance
      username
    }
  }
`;

export const SET_ACCOUNT_TO_RECOVER = gql`
  mutation setAccountToRecover($accountToRecover: AccountToRecover) {
    setAccountToRecover(accountToRecover: $accountToRecover) @client
  }
`;

export const LOGIN_BAU_USER = gql`
  mutation bauLoginByLegacyData($input: BauLoginByLegacyDataInput!) {
    bauLoginByLegacyData(input: $input)
  }
`;
